import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SearchBar from '@pedidosya/web-fenix/organisms/SearchBar';

import { onKeyDownFunction, onKeyUpFunction } from '@utils/a11y';

const Container = styled.div`
  background: white;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
`;

const Bar = styled.span`
  position: relative;
  display: block;
  width: 100%;
  top: 2px;
`;

const SearchInput = React.forwardRef(
  (
    {
      style,
      disabled,
      value,
      showCleanIcon,
      placeholder,
      onChange,
      onClick,
      onEnterPressed,
      autoFocus,
      border,
      background,
    },
    ref,
  ) => (
    <Container
      onClick={() => onClick && onClick()}
      onKeyUp={
        disabled
          ? e => onKeyUpFunction(e, () => onClick && onClick())
          : () => null
      }
      onKeyDown={
        disabled
          ? e => onKeyDownFunction(e, () => onClick && onClick())
          : () => null
      }
      role="button"
      tabIndex={0}
      border={border}
      background={background}
      aria-label="Buscador"
    >
      <SearchBar
        variant="special"
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        style={style}
        onChange={({ target }) => onChange(target.value)}
        onKeyPress={({ key }) => {
          if (key === 'Enter' && onEnterPressed) onEnterPressed();
        }}
        ref={ref}
        autoFocus={autoFocus}
        id="search_input"
        background={background}
        withReset={showCleanIcon && Boolean(value.length > 0)}
        onClickIcon={() => {
          onChange('');
          if (ref?.current) ref.current.focus();
        }}
      />

      <Bar />
    </Container>
  ),
);

SearchInput.displayName = 'SearchInput';

SearchInput.propTypes = {
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onEnterPressed: PropTypes.func,
  style: PropTypes.object,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  showCleanIcon: PropTypes.bool,
  autoFocus: PropTypes.bool,
  border: PropTypes.bool,
  background: PropTypes.string,
};

SearchInput.defaultProps = {
  style: {},
  placeholder: '',
  disabled: false,
  value: '',
  showCleanIcon: false,
  autoFocus: false,
  border: false,
  background: 'secondary',
};

SearchInput.displayName = 'SearchInput';

export default SearchInput;
